import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { logoutAsync } from '../redux/authSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faPowerOff, faTowerCell } from '@fortawesome/free-solid-svg-icons';
import AdminPanel from './Dashboard/AdminPanel';
import { /* faBell */ } from '@fortawesome/free-regular-svg-icons';
import useSessionExpiry from '../hooks/useSessionExpiry';

import '../styles/logo.css';
import Spinner from 'react-bootstrap/Spinner';



const Layout = () => {
  useSessionExpiry(); 
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rol = useSelector((state) => state.auth.usuario.rol);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  
  const cambioClave = useSelector((state) => state.auth.cambioClave);
  const completarEmergencia = useSelector((state) => state.auth.completarEmergencia);
  const [fechaHora, setFechaHora] = useState('');
  const usuario = useSelector((state) => state.auth.usuario);
  const isLoading = useSelector((state) => state.auth.isLoading);

  // Obtener el ID del usuario autenticado
  //const usuarioId = useSelector((state) => state.auth.usuario.id);

  useEffect(() => {
    if (isAuthenticated) {
      if (cambioClave || completarEmergencia) {
        navigate('/cambio-clave');
      }
    }
  }, [isAuthenticated, cambioClave, completarEmergencia, rol, navigate]);

  // En tu componente Layout.js, modifica el efecto para manejar el foco
  useEffect(() => {
    // Mover el foco al contenido principal después de la carga
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      mainContent.focus();
      mainContent.setAttribute('tabindex', '-1');
    }
  }, []);

 
  // Actualizar la fecha y hora cada segundo
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const options = { day: 'numeric', month: 'long', year: 'numeric' };
      setFechaHora(now.toLocaleDateString('es-ES', options));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Manejar la desconexión de Socket.IO al cerrar sesión
  const handleLogout = () => {
    dispatch(logoutAsync())
      .unwrap()
      .then(() => {

        
        navigate('/login');
      })
      .catch((error) => {
        console.error('Error al cerrar sesión:', error);
        alert('No se pudo cerrar la sesión. Inténtalo nuevamente.');
      });
  };

  return (

    <div className="d-flex flex-column min-vh-100" role="document">
      <a href="#main-content" className="visually-hidden-focusable">
        Saltar al contenido principal
      </a>
      {/* Navbar principal */}
      <Navbar
        bg="danger"
        expand="lg"
        variant="dark"
        className="mb-2"
        aria-label="Navegación principal"
      >
        <Container>
          <Navbar.Brand href="/" aria-label="Inicio - Sindicato Claro">
            <FontAwesomeIcon
              icon={faTowerCell}
              bounce
              size="lg"
              style={{ color: '#bababa' }}
              aria-hidden="true"
            />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            aria-label="Alternar navegación"
          />
          <Navbar.Collapse id="basic-navbar-nav" role="navigation" aria-label="Menú principal">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/" aria-label="Ir a página de inicio">Inicio</Nav.Link>
              <Nav.Link as={Link} to="/noticias" aria-label="Ir a noticias">Noticias</Nav.Link>
              <Nav.Link as={Link} to="/directiva-sindicato" aria-label="Ir a directiva del sindicato">
                Directiva Sindicato
              </Nav.Link>
              <Nav.Link as={Link} to="/beneficios" aria-label="Ir a beneficios">Beneficios</Nav.Link>
              <Nav.Link as={Link} to="/convenios" aria-label="Ir a convenios">Convenios</Nav.Link>
              <Nav.Link as={Link} to="/preguntas-frecuentes" aria-label="Ir a Preguntas Frecuentas (FAQ)">Preguntas Frecuentes</Nav.Link>
              {isAuthenticated && (
                <Nav.Link as={Link} to="/documentos" aria-label="Ir a documentos">Documentos</Nav.Link>
              )}
              {!isAuthenticated && (
                <Nav.Link as={Link} to="/login" aria-label="Iniciar sesión">Mi Sindicato</Nav.Link>
              )}
            </Nav>
            <Nav className="ms-auto d-flex align-items-center">
              
              <span className="me-3 text-white" aria-live="polite">
                {fechaHora}
              </span>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Navbar adicional para usuarios autenticados */}
      {isAuthenticated && (
        <Container fluid className="px-0">
          <Navbar
            bg="dark"
            data-bs-theme="dark"
            className="mb-4 py-2"
            aria-label="Navegación de usuario"
          >
            <Container>
              <div className="d-flex flex-column flex-md-row w-100 align-items-md-center">
                <div className="w-100 w-md-auto mb-2 mb-md-0 me-md-3 text-center text-md-start">
                  <Navbar.Brand
                    as={Link}
                    to="/"
                    className="p-0 m-0 text-truncate"
                    aria-label={`Hola ${usuario.nombre || 'Usuario'}, Bienvenido(a)`}
                  >
                    Hola <strong>{usuario.nombre || 'Usuario'}</strong>, Bienvenido(a)!
                  </Navbar.Brand>
                </div>

                <div className="d-flex flex-column flex-md-row w-100 justify-content-between align-items-center">
                  <Nav
                    className="d-flex flex-wrap justify-content-center justify-content-md-start my-2 my-md-0"
                    role="navigation"
                    aria-label="Menú de usuario"
                  >
                    <Nav.Item className="mx-1 mx-md-2">
                      <Nav.Link
                        as={Link}
                        to="/profile"
                        className="text-white text-nowrap"
                        aria-label="Ir a perfil de usuario"
                      >
                        <i className="bi bi-person me-1" aria-hidden="true"></i>
                        Perfil
                      </Nav.Link>
                    </Nav.Item>

                    <Nav.Item className="mx-1 mx-md-2">
                      <Nav.Link
                        as={Link}
                        to="/encuestas"
                        className="text-white text-nowrap"
                        aria-label="Ir a encuestas"
                      >
                        <i className="bi bi-clipboard-check me-1" aria-hidden="true"></i>
                        Encuestas
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>

                  <div className="d-flex flex-wrap justify-content-center justify-content-md-end align-items-center mt-2 mt-md-0">
                    <div className="me-2 me-md-3 mb-1 mb-md-0" style={{ minHeight: '32px', minWidth: '40px' }}>
                      {isLoading ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          variant="light"
                          aria-label="Cargando panel de administración"
                        />
                      ) : (
                        isAuthenticated && (usuario?.rol === 'admin' || isAdmin) &&
                        <AdminPanel aria-label="Panel de administración" />
                      )}
                    </div>

                    <Button
                      variant="outline-light"
                      onClick={handleLogout}
                      className="text-nowrap"
                      size="sm"
                      aria-label="Cerrar sesión"
                    >
                      <FontAwesomeIcon icon={faPowerOff} className="me-1" aria-hidden="true" />
                      Cerrar Sesión
                    </Button>
                  </div>
                </div>
              </div>
            </Container>
          </Navbar>
        </Container>
      )}

      {/* Contenido principal */}
      <main
        id="main-content"
        className="flex-grow-1"
        tabIndex="-1"
        aria-labelledby="main-heading"
      >
        <Container>
          <h1 id="main-heading" className="visually-hidden">Contenido principal</h1>
          <Outlet />
        </Container>
      </main>

      {/* Footer */}
      <footer
        className="bg-danger text-light py-3 mt-4"
        role="contentinfo"
        aria-label="Pie de página"
      >
        <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <p className="mb-0 text-center text-md-start">
            &copy; {new Date().getFullYear()} SINTEREC CLARO. Todos los derechos reservados.
          </p>
          <div className="d-flex flex-column flex-md-row align-items-center">
            <Nav.Link as={Link} to="/" className="text-light" aria-label="Ir a inicio">Inicio</Nav.Link>
            <Nav.Link as={Link} to="/noticias" className="text-light ms-md-3" aria-label="Ir a noticias">Noticias</Nav.Link>
            <Nav.Link as={Link} to="/directiva-sindicato" className="text-light ms-md-3" aria-label="Ir a directiva del sindicato">
              Directiva Sindicato
            </Nav.Link>
            <Nav.Link as={Link} to="/beneficios" className="text-light ms-md-3" aria-label="Ir a beneficios">Beneficios</Nav.Link>
            <Nav.Link as={Link} to="/convenios" className="text-light ms-md-3" aria-label="Ir a convenios">Convenios</Nav.Link>
            <Nav.Link as={Link} to="/privacidad" className="text-light ms-md-3" aria-label="Política de privacidad">
              Política de Privacidad
            </Nav.Link>
            <a
              href="https://github.com/WilldiazRaM"
              target="_blank"
              rel="noopener noreferrer"
              className="text-light ms-md-3"
              style={{ fontSize: '1.5rem' }}
              aria-label="Repositorio en GitHub (se abre en nueva ventana)"
            >
              <FontAwesomeIcon icon={faGithub} aria-hidden="true" />
            </a>
          </div>
        </Container>
      </footer>
    </div>
  );
};

export default Layout;